class DigitalNatureCarouselControlComponent extends HTMLElement
{
    carousel = null;
    links = null;

    constructor() {
        super();

        // bind the controls to the carousel
        this.bindToCarousel();

        // initialise the links
        this.initialiseLinks(this.getElementsByTagName('a'));

        this.addClickHandler();
    }


    /** GETTERS **/
    getActiveLink()
    {
        for (let link of this.links) {
            if (link.classList.contains('active')) {
                return link;
            }
        }
        return null;
    }

    getLinkByHref(href)
    {
        for (let link of this.links) {
            if (this.getLinkHref(link) === href) {
                return link;
            }
        }

        return null;
    }

    getLinkHref(link)
    {
        return link.attributes.href.value;
    }





    /** SETTERS **/
    setActiveLink(activeLinkHref)
    {
        // remove the active class from the current active link
        let currentActiveLink = this.getActiveLink();
        if (currentActiveLink) {
            currentActiveLink.classList.remove('active');
        }

        // get the new active link
        let activeLink = this.getLinkByHref(activeLinkHref);

        if (!activeLink) {
            console.error(`No link found with href ${activeLinkHref}`);
            return;
        }

        // add the active class to the new active link
        activeLink.classList.add('active');
    }





    /** UTILITIES **/
    /**
     * Links this control set to the carousel
     */
    bindToCarousel() {
        let carouselId = this.dataset.carouselId;
        if (carouselId) {
            let carousel = document.getElementById(carouselId);
            if (carousel) {
                this.carousel = carousel;
                carousel.addControl(this);
            }
        }
    }

    /**
     * Initialises the links within this control, setting the active link if required
     *
     * @param {Array} links
     */
    initialiseLinks(links)
    {
        this.links = links;

        if (this.links.length === 0) {
            return;
        }

        // set the active link up correctly, for colours/highlighting etc.
        let activeLink = this.getActiveLink();

        if (!activeLink) {
            // if there's a page hash, then we will check for that in the links and activate that one
            if (window.location.hash) {
                activeLink = this.getLinkByHref(window.location.hash);
            }

            if (activeLink == null) {
                // if no active link and no hash then we pick the first item
                activeLink = this.links[0];
            }
        }

        // we found a link, set it as active
        this.setActiveLink(this.getLinkHref(activeLink));
    }

    /**
     * Changes the active slide in the carousel, this will propagate
     * to all carousel controls
     *
     * @param target
     */
    updateCarouselActiveSlide(target) {
        if (!this.carousel) {
            return;
        }

        this.carousel.setActiveSlide(target);
    }




    /** EVENT HANDLERS **/
    addClickHandler()
    {
        let carouselControls = this;
        // add click event listener to each button
        this.addEventListener('click', function(event) {
            // get the clicked link
            let clickedLink = event.target;

            // abort if it wasn't a link that was clicked
            if (!clickedLink.matches('a')) {
                return;
            }

            // change the active slide
            carouselControls.updateCarouselActiveSlide(carouselControls.getLinkHref(clickedLink))
        })
    }

}

// add the custom element to the registry
customElements.define('digital-nature-carousel-control', DigitalNatureCarouselControlComponent);